<template>
    <div>
        <!-- <img src="../assets/index2.jpg" style="width:100%;">
        <img src="../assets/zh.png"> -->
        <el-carousel class="imgh1" arrow="never" :interval="7000" trigger="click">
            <el-carousel-item v-for="item in imgurls" :key="item" class="imgh1">
                <img :src="item" alt="" width="100%" @click="$router.push('/search')" class="cp imgh">
                <!-- <div :id="$style.cas" class="dflex fc pr">
                    <div v-if="item === index1" class="pa dflex fc" style="top:170px;left: 150px;">
                        <img :src="index11url" alt="" width="530">
                        <div class="dflex">
                            <span class="f1"></span>
                            <ubutton :text="$t('search')" class="dib" style="margin-top:30px;" @click="$router.push('/search')"></ubutton>
                            <span class="f1"></span>
                        </div>
                    </div>
                    <template v-else>
                        <div class="pa" style="right: 340px; bottom: 150px;">
                            <ubutton :text="$t('search')" class="dib" style="margin-top:20px;" @click="$router.push('/search')"></ubutton>
                        </div>
                        <div class="pa backwhite" style="right: 0px; bottom: 0px; width:60px; height: 100px;"></div>
                    </template>
                </div> -->
            </el-carousel-item>
        </el-carousel>
        <div class="dflex i1">
            <div class="backwhite center i11">
                <p class="fs28">{{ $t('relax') }}</p>
                <p class="fs24">01</p>
            </div>
            <div class="backyel w100"></div>
            <div class="f1 backblack white i12 showInLarge">
                <p class="fs28 mb30">{{ $t('ihelp') }}</p>
                <p class="fs14">
                    <span>{{ $t('ibo') }}</span>
                    <span style="padding-left:50px;">{{ $t('ioro') }}</span>
                </p>
            </div>
            <div class="f1 backblack white showInSmall">
                <p class="fs28 mb30" style="margin-top: 10px;line-height:1;padding-left:30px;">{{ $t('ihelp') }}</p>
                <p class="fs14" style="padding-left:30px;">
                    <span>{{ $t('ibo') }}</span>
                    <span style="padding-left:36px;">{{ $t('ioro') }}</span>
                </p>
            </div>
        </div>
        <div class="center i2">
            <p class="black fs38 fw500">{{ $t('company') }}</p>
            <span class="backyel dib" style="width: 80px;height: 6px;margin: 14px 0 30px;"></span>
            <p class="gray fs18 i2s">
                {{ $t('id1') }}<br>
                {{ $t('id2') }}<br>
                {{ $t('id3') }}<br>
            </p>
        </div>
        <div class="showInLarge">
            <div class="dflex" style="margin: 40px 140px;">
                <div class="f1 dflex fc" style="margin-left: 10%;">
                    <div class="f1"></div>
                    <div>
                        <lay1 :head="$t('ih1')" :content="$t('ic1')" class="mb30"></lay1>
                        <ubutton :text="$t('more')" @click="$router.push('/search')"></ubutton>
                    </div>
                    <div class="f1"></div>
                </div>
                <img src="../assets/index3.png" alt="" width="60%;">
				<!-- <img src="../assets/index3-newyear.png" alt="" width="60%;"> -->
            </div>
            <div class="dflex" style="margin: 40px 140px;">
                <img src="../assets/index4.png" alt="" width="60%;">
				<!-- <img src="../assets/index4-newyear.png" alt="" width="60%;"> -->
                <div class="f1 dflex fc">
                    <div class="f1"></div>
                    <div>
                        <lay1 :head="$t('ih2')" :content="$t('ic2')" class="mb30"></lay1>
                        <ubutton :text="$t('more')" @click="$router.push('/pay')"></ubutton>
                    </div>
                    <div class="f1"></div>
                </div>
            </div>
            <div class="dflex" style="margin: 40px 140px;">
                <div class="f1 dflex fc" style="margin-left: 10%;">
                    <div class="f1"></div>
                    <div>
                        <lay1 :head="$t('ih3')" :content="$t('ic3')" class="mb30"></lay1>
                        <ubutton :text="$t('more')" @click="$router.push('/onlineRenew')"></ubutton>
                    </div>
                    <div class="f1"></div>
                </div>
                <img src="../assets/index5.png" alt="" width="60%;">
				<!-- <img src="../assets/index5-newyear.png" alt="" width="60%;"> -->
            </div>
        </div>
        <div class="showInSmall dflex fc">
            <div class="dflex fcenter">
                <img src="../assets/index3.png" alt="" :class="$style.mpi">
				<!-- <img src="../assets/index3-newyear.png" alt="" :class="$style.mpi"> -->
            </div>
            <div class="center" style="padding:30px;">
                <lay1 :head="$t('ih1')" :content="$t('ic1')" class="mb30"></lay1>
                <ubutton :text="$t('more')" @click="$router.push('/search')" style="margin-top:20px;"></ubutton>
            </div>
            <div class="dflex fcenter">
                <img src="../assets/index4.png" alt="" :class="$style.mpi">
				<!-- <img src="../assets/index4-newyear.png" alt="" :class="$style.mpi"> -->
            </div>
            <div class="center" style="padding:30px;">
                <lay1 :head="$t('ih2')" :content="$t('ic2')" class="mb30"></lay1>
                <ubutton :text="$t('more')" @click="$router.push('/pay')" style="margin-top:20px;"></ubutton>
            </div>
            <div class="dflex fcenter">
                <img src="../assets/index5.png" alt="" :class="$style.mpi">
				<!-- <img src="../assets/index5-newyear.png" alt="" :class="$style.mpi"> -->
            </div>
            <div class="center" style="padding:30px;">
                <lay1 :head="$t('ih3')" :content="$t('ic3')" class="mb30"></lay1>
                <ubutton :text="$t('more')" @click="$router.push('/onlineRenew')" style="margin-top:20px;"></ubutton>
            </div>
        </div>
        <div class="center white backblack i3">
            <p class="fs38 fw500 mb30">{{ $t('iss') }}</p>
            <p class="gray fs18 mb30 i31">
                {{ $t('iss1') }}<br>
                {{ $t('iss2') }}<br>
            </p>
            <ubutton :text="$t('explore')" class="black" @click="$router.push('/search')"></ubutton>
        </div>
        <div class="center pt100">
            <p class="black fs38 fw500">{{ $t('touch') }}</p>
            <span class="backyel dib" style="width: 80px;height: 6px;margin: 14px 0 30px;"></span>
            <p class="gray fs18 i4">
                {{ $t('touch1') }}
            </p>
        </div>
        <div style="margin-top:30px" class="dflex fcenter">
            <div class="fs16 gray vat dflex fw i5 acsb" style="padding-bottom: 20px;">
                <div v-for="item in companies" :key="item.name" style="margin-bottom: 20px;width: 50%;">
                    <p class="yel fs18 fw500" style="padding-bottom:10px;">{{ item.name }}
                        {{item.isMain? ($i18n.locale === 'en' ? ' (':'（')+$t('maino')+($i18n.locale === 'en'?')':'）') : ''}}
                    </p>
                    <p class="dflex" v-for="person in item.persons" :key="person.name">
                        <span class="f1">
                            <span>{{ person.name }}</span><br>
                            <span>({{ person.role }})</span>
                        </span>
                        <span class="i6">
                            <i class="el-icon-phone showInLarge"></i>
                            {{person.mobilePrefix}} {{ person.mobile }}
                        </span>
                    </p>
                </div>
            </div>
            <!-- <img :src="contacturl" alt="" style="width: 45%;margin-top: 30px;"> -->
            <!-- <div class="f1"></div>
            <div class="dib">
                <input type="text" :placeholder="$t('phone')" class="db input" ref="mobile">
                <input type="text" :placeholder="$t('name')" class="db input" ref="name">
                <textarea type="text" :placeholder="$t('message')" class="db input" rows="6" ref="content"></textarea>
                <div class="center">
                    <ubutton :text="$t('send')" @click="leaveMessage"></ubutton>
                </div>
            </div>
            <div class="dib fs14 gray vat" style="margin: 15px 40px;width: 16%;">
                <div v-for="item in companies" :key="item.name" style="margin-bottom: 10px;">
                    <p class="yel fs18 fw500">{{ item.name }}</p>
                    <p class="dflex">
                        <span class="f1">
                            <span>{{ item.person }}</span><br>
                            <span>({{ item.role }})</span>
                        </span>
                        <span style="padding-top: 10px;width:120px;">
                            <i class="el-icon-phone"></i>
                            {{ item.phone }}
                        </span>
                    </p>
                </div>
            </div>
            <div class="f1"></div> -->
        </div>
    </div>
</template>
<script>
import {companies} from '../data.js';
import index1en from '../assets/index1en11.png';
import index1zh from '../assets/index1zh11.jpg';
import index2en from '../assets/index2en1.png';
import index2zh from '../assets/index2zh1.png';
import contacten from '../assets/contacten.png';
import contactzh from '../assets/contactzh.png';

/**2021圣诞**/
import indexsd1en from '../assets/indexsd1en.jpg';
import indexsd1zh from '../assets/indexsd1zh.jpg';
import indexsd2en from '../assets/indexsd2en.jpg';
/**2022春节**/
// import indexnewyear1en from '../assets/skin/indexnewyear1en.jpg';
// import indexnewyear1zh from '../assets/skin/indexnewyear1zh.jpg';
// import indexnewyear2en from '../assets/skin/indexnewyear2en.png';
export default {
    name: 'Index',
    data() {
        // const index11url = this.$i18n.locale === 'en' ? index11en : index11zh;
        // const index12url = this.$i18n.locale === 'en' ? index12en : index12zh;
        const index1url = this.$i18n.locale === 'en' ? index1en : index1zh;
        const index2url = this.$i18n.locale === 'en' ? index2en : index2zh;
		
		// const index1url = this.$i18n.locale === 'en' ? indexsd1en : indexsd1zh;
		// const index2url = indexsd2en;
		
		// const index1url = this.$i18n.locale === 'en' ? indexnewyear1en : indexnewyear1zh;
		// const index2url = this.$i18n.locale === 'en' ? index2en : index2zh;
        const contacturl = this.$i18n.locale === 'en' ? contacten : contactzh;
        return {
            companies,
            // index1,
            // index11url,
            // imgurls: [index1, index12url],
            imgurls: [index1url, index2url],
            contacturl,
        };
    },
    created() {
        this.$top();
    },
    methods: {
        leaveMessage() {
            this.$service.leaveMessage({
                mobile: this.$refs.mobile.value || '',
                name: this.$refs.name.value || '',
                content: this.$refs.content.value || '',
            });
        },
    }
}
</script>
<style module>
#cas {
    height: 600px;
    /* background: url(../assets/index1.jpg) no-repeat;
    background-size: cover; */
}
.mpi {
    width: 80%;
    height: 80%;
}
</style>
